import { DateTime } from 'luxon'
import { Courier, CourierService } from '../../../interfaces/Courier'
import * as Yup from 'yup'
import { createColumns } from '../../../components/_EOS/GenericTable'
import { YesNoBadge } from '../../../components/YesNoBadge'
import React from 'react'

export const NAME_MAX_LENGTH = 100

export const initialFormValues: Courier = {
  courierId: 0,
  name: '',
  createdAt: DateTime.now().toJSDate(),
  courierServices: [],
  hasPriorization: false,
  active: true
}

export const courierFormvalidationSchema = Yup.object({
  name: Yup.string().trim().required('Requerido'),
  courierServices: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().trim().required('Requerido')
    })
  )
})

export const sectionPaperSx = {
  p: 2,
  bgcolor: 'grey.50',
  borderLeft: '4px solid #1976d2',
  borderRadius: 2
}

export const sectionTitleSx = {
  fontWeight: 700,
  letterSpacing: 1.2,
  color: '#1976d2',
  display: 'block',
  marginBottom: 1
}

export interface DraftService extends CourierService {
  isNew: boolean
  isDeleted: boolean
}

export const createServiceColumns = (
  priorityLabel: (typePriorityId: number | null) => string
) =>
  createColumns<DraftService>([
    { key: 'name', title: 'Servicio', align: 'center' },
    {
      key: 'typePriorityId',
      title: 'Tipo de Prioridad',
      align: 'center',
      render: (value) => priorityLabel(value as number | null)
    },
    {
      key: 'active',
      title: 'Activo',
      align: 'center',
      render: (value) => <YesNoBadge value={value as boolean} />
    }
  ])
